"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Fri Nov 09 2018
 */

var typescript_ioc_1 = require("@logio/typescript-ioc");

var InternalProductPricesDTO_1 = require("../../../product/model/InternalProductPricesDTO");

var InternalProductPricesDTOConverter_1 = require("./InternalProductPricesDTOConverter");

var PriceZoneProductPriceConverter_1 = require("./PriceZoneProductPriceConverter");
/**
 * Implementation of InternalProductPricesDTOConverter
 *
 * @author RV
 */


var InternalProductPricesDTOConverterImpl =
/*#__PURE__*/
function (_InternalProductPrice) {
  _inherits(InternalProductPricesDTOConverterImpl, _InternalProductPrice);

  function InternalProductPricesDTOConverterImpl(priceZoneProductPriceConverter) {
    var _this;

    _classCallCheck(this, InternalProductPricesDTOConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InternalProductPricesDTOConverterImpl).call(this));
    _this.priceZoneProductPriceConverter = priceZoneProductPriceConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(InternalProductPricesDTOConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new InternalProductPricesDTO_1.InternalProductPricesDTO(InternalProductPricesDTO_1.InternalProductPricesDTO.schema.internalProductId.valueOf(conversions.toClassReferenceId(source.internalProductId)), InternalProductPricesDTO_1.InternalProductPricesDTO.schema.purchasePrice.valueOf(conversions.toBigNumber(source.purchasePrice)), source.openPurchasePrice ? InternalProductPricesDTO_1.InternalProductPricesDTO.schema.openPurchasePrice.valueOf(conversions.toBigNumber(source.openPurchasePrice)) : null, InternalProductPricesDTO_1.InternalProductPricesDTO.schema.prices.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this2 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        internalProductId: conversions.toDocumentReferenceId(source.internalProductId),
        purchasePrice: conversions.fromBigNumber(source.purchasePrice),
        openPurchasePrice: source.openPurchasePrice ? conversions.fromBigNumber(source.openPurchasePrice) : null,
        prices: conversions.asObjectArray(source, 'prices', function (p) {
          return _this2.priceZoneProductPriceConverter.toDocument(p, conversions);
        })
      });
      return result;
    }
  }]);

  return InternalProductPricesDTOConverterImpl;
}(InternalProductPricesDTOConverter_1.InternalProductPricesDTOConverter);

InternalProductPricesDTOConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [PriceZoneProductPriceConverter_1.PriceZoneProductPriceConverter])], InternalProductPricesDTOConverterImpl);
exports.InternalProductPricesDTOConverterImpl = InternalProductPricesDTOConverterImpl;